<template>
    <div>
        <!-- Basic Filters -->
        <div class="flex justify-content-center mb-3">
            <label>Epoch<b-form-select v-model="slots" :options="epochs" class="form-control" @input="updateFilter"></b-form-select></label>
            <label>Leader<b-form-select class="form-control" v-model="leader" :options="leaders" :multiple="false" :close-on-select="true" :placeholder="'Select Leader'" @input="updateFilter"></b-form-select></label>
            <label>Per Page<b-form-select v-model="perPage" class="form-control" :options="[5,50,100,250,500]"></b-form-select></label>
        </div>

        <!-- Advanced Filters Toggle -->
        <div class="text-center mb-3">
            <button 
                @click="showAdvanced = !showAdvanced" 
                class="btn btn-outline-secondary btn-sm"
            >
                <i :class="showAdvanced ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                Advanced Filters
            </button>
        </div>

        <!-- Advanced Filters Panel -->
        <div v-show="showAdvanced" class="card mb-4">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <label class="form-label">Slot Range</label>
                        <div class="d-flex gap-2">
                            <input 
                                v-model.number="customSlotRange.min" 
                                type="number" 
                                class="form-control" 
                                placeholder="Min Slot"
                                @input="updateCustomSlotFilter"
                            >
                            <input 
                                v-model.number="customSlotRange.max" 
                                type="number" 
                                class="form-control" 
                                placeholder="Max Slot"
                                @input="updateCustomSlotFilter"
                            >
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Date Range</label>
                        <el-date-picker
                            v-model="dateRange"
                            type="datetimerange"
                            range-separator="To"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            format="YYYY-MM-DD HH:mm:ss"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            @change="updateDateFilter"
                            class="w-100"
                        />
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <button @click="clearAdvancedFilters" class="btn btn-outline-danger btn-sm">
                            Clear Advanced Filters
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Block Metrics Chart -->
<!--        <div class="mb-4">
            <h5>Block Metrics Over Time</h5>
            <bl1ock-metrics-chart 
                v-if="filtersInitialized"
                :filters="chartFilters"
            />
            <div v-else class="text-center p-4">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    -->    
        <!-- Data Source Legend -->
        <div class="mb-3 p-2 bg-light rounded">
            <small><strong>Data Sources:</strong></small>
            <span class="ml-2" style="color: black;">■ Solana RPC</span>
            <span class="ml-2" style="color: #1e40af;">■ Firedancer WS</span>
        </div>

        <vuetable ref="vuetable" api-url="/blocks/query"
                  :load-on-start="false"
                  :fields="[
                  {name:'slot', sortField: 'slot', title: 'Slot', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'block_time', sortField: 'block_time', title: 'Time', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'block_duration', sortField: 'block_fd.duration_nanos', title: 'Block Duration (ms)', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'leader.leader', sortField: 'leader.leader', title: 'Leader', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'skipped', sortField: 'skipped', title: 'Skipped', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'txns', sortField: 'txns', title: '# Tx', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'votes', sortField: 'votes', title: '# Votes', titleClass: 'text-center', dataClass: 'text-center'},

                  {name:'nonvotes', sortField: 'nonvotes', title: '# Non-Votes', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'success', sortField: 'success', title: 'Successful', titleClass: 'text-center', dataClass: 'text-center'},
                  {name:'failed', sortField: 'failed', title: 'Failed', titleClass: 'text-center', dataClass: 'text-center'},
                  // {name: 'total', sortField: 'rewards', title: 'Total Fees', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'rewards', sortField: 'rewards', title: 'Validator Rewards', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'fees.jito_total', sortField: 'fees.jito_total', title: 'Jito Tips', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'jito_percentage', sortField: 'fees.jito_transactions', title: '% Jito', titleClass: 'text-center', dataClass: 'text-center'},
                  // {name: 'fees.count', sortField: 'fees.count', title: '# Priority', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'fees.percentage', sortField: 'fees.percentage', title: '% Priority', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'fees.total', sortField: 'fees.total', title: 'Priority Fees', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'fees.average', sortField: 'fees.average', title: 'Average Priority', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'fees.max', sortField: 'fees.max', title: 'Max Priority Fee', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'cu'  , sortField: 'cu', title: 'CU', titleClass: 'text-center', dataClass: 'text-center'},
                  {name: 'rev_per_cu', title: 'Rev/CU', titleClass: 'text-center', dataClass: 'text-center'},
                  ]"
                  :per-page="perPage"
                  :append-params="filters"
                  :reactive-api-url="true"
                  @vuetable:pagination-data="onPaginationData"

                  data-path="data"
                  pagination-path=""

                  :css="tableCss"
        >
            <template #nonvotes="props">
                {{ props.rowData.txns - props.rowData.votes }}
            </template>
            <template #leader.leader="props">
                <a :href="'/validators/' + voteIds[props.rowData.leader.leader]"
                   class="text-blue-500">{{ formatKey(props.rowData.leader.leader) }}</a>
            </template>
            <template #total="props">
                {{ formatSol(props.rowData.rewards *2) }}
            </template>
            <template #rewards="props">
                <span v-if="props.rowData.rewards === 0 && props.rowData.block_fd" 
                      style="color: #1e40af;" 
                      :title="'Firedancer data: ' + formatSol(getFdTotalFees(props.rowData.block_fd))">
                    {{ formatSol(getFdTotalFees(props.rowData.block_fd)) }}
                </span>
                <span v-else>
                    {{ formatSol(props.rowData.rewards) }}
                </span>
            </template>
            <template #fees.total="props">
                {{ formatSol(calculatePriorityFees(props.rowData)) }}
            </template>

            <template #fees.average="props">
                {{ formatSol(props.rowData.fees?.average) }}
            </template>
            <template #fees.jito_total="props">
                {{ formatSol(props.rowData.fees?.jito_total) }}
            </template>
            <template #jito_percentage="props">
                <span :title="getJitoTooltip(props.rowData)">
                    {{ calculateJitoPercentage(props.rowData) }}%
                </span>
            </template>
            <template #fees.max="props">
                {{ formatSol(props.rowData.fees?.max) }}
            </template>
            <template #cu="props">
                <span v-if="props.rowData.block_fd && props.rowData.block_fd.compute_units"
                      style="color: #1e40af;"
                      :title="'Firedancer data: ' + formatCu(props.rowData.block_fd.compute_units) + 'm'">
                    {{ formatCu(props.rowData.block_fd.compute_units) }}m
                </span>
                <span v-else>
                    {{ formatCu(props.rowData.cu) }}m
                </span>
            </template>
            <template #rev_per_cu="props">
                <span :title="getRevPerCuTooltip(props.rowData)">
                    {{ calculateRevPerCu(props.rowData) }}
                </span>
            </template>
            <template #block_duration="props">
                <span v-if="props.rowData.block_fd && props.rowData.block_fd.duration_nanos" 
                      style="color: #1e40af;" 
                      :title="'Firedancer data'">
                    {{ formatDuration(props.rowData.block_fd.duration_nanos) }}
                </span>
                <span v-else>
                    -
                </span>
            </template>
            <template #fees.percentage="props">
                <span :title="getPriorityTooltip(props.rowData)">
                    {{ calculatePriorityPercentage(props.rowData) }}%
                </span>
            </template>
            <template #skipped="props">
                <span v-if="props.rowData.skipped" class="text-danger">Yes</span>
                <span v-else class="text-success">No</span>
            </template>
            <template #slot="props">

                <a target=_blank :href="'https://explorer.solana.com/block/' + props.rowData.slot" class="text-blue-500">{{ props.rowData.slot }}</a>
            </template>


        </vuetable>
        <vuetable-pagination ref="pagination"
                             @vuetable-pagination:change-page="onChangePage"
                             :css="paginationCss"
        ></vuetable-pagination>
    </div>
</template>

<script>

import Select2 from 'vue3-select2-component';
export default {
    name: "BlockExplorer",
    props: ['leaders', 'filterLeader', 'filterSlots','voteIds','epochs','filterEpoch'],
    components: {
        Select2
    },
    data() {
        return {
            perPage: 50,
            slots: [],
            leader: null,
            epoch: null,
            showAdvanced: false,
            customSlotRange: {
                min: null,
                max: null
            },
            dateRange: null,
            useCustomSlots: false,
            useDateRange: false,
            filtersInitialized: false,
            tableCss: {
                tableWrapper: '',
                tableHeaderClass: 'mb-0',
                tableBodyClass: 'mb-0',
                tableClass: 'table table-sm table-striped table-hover',
                loadingClass: 'loading',
                ascendingIcon: 'fa fa-chevron-up',
                descendingIcon: 'fa fa-chevron-down',
                ascendingClass: 'sorted-asc',
                descendingClass: 'sorted-desc',
                sortableIcon: 'fa fa-sort',
                detailRowClass: 'vuetable-detail-row',
                handleIcon: 'fa fa-bars text-secondary',
                renderIcon(classes, options) {
                    return `<i class="${classes.join(' ')}"></span>`
                }
            },
            paginationCss: {
                wrapperClass: 'pagination float-right',
                activeClass: 'active',
                disabledClass: 'disabled',
                pageClass: 'page-item',
                linkClass: 'page-link',
                paginationClass: 'pagination',
                paginationInfoClass: 'float-left',
                dropdownClass: 'form-control',
                icons: {
                    first: 'fa fa-chevron-left',
                    prev: 'fa fa-chevron-left',
                    next: 'fa fa-chevron-right',
                    last: 'fa fa-chevron-right',
                }

            },
            pageUrl: '',
            page: 1,
        }
    },
    mounted() {
        if (this.filterLeader) {
            this.leader = this.filterLeader;
        }
        if (this.filterSlots) {
            this.slots = this.filterSlots;
        }
        if (this.filterEpoch) {
            // this.slots = this.filterEpoch;
        }
        this.updateFilter();
        
        // Mark filters as initialized after a short delay to ensure everything is set up
        this.$nextTick(() => {
            this.filtersInitialized = true;
        });
    },
    methods: {
        formatNumber(value) {
            return value.toLocaleString();
        },
        formatSol(amount) {
            return (amount / 1000000000).toFixed(5);
        },
        formatCu(amount) {
            return (amount / 1000000).toFixed(2);
        },
        formatDuration(nanos) {
            // Convert nanoseconds to milliseconds
            return (nanos / 1000000).toFixed(2);
        },
        getFdTotalFees(blockFd) {
            if (!blockFd) return 0;
            // Sum transaction_fee, priority_fee, and tips from Firedancer data
            const transactionFee = blockFd.transaction_fee || 0;
            const priorityFee = blockFd.priority_fee || 0;
            const tips = blockFd.tips || 0;
            return transactionFee + priorityFee + tips;
        },
        formatLeader(leader) {
            return this.leaders[leader]?.name || leader;
        },
        formatKey(address) {
            if (this.leaders[address]) {
                return this.leaders[address].substr(0, "Solana Compass".length) + '...';
            }

            return address.substr(0, 4) + '...' + address.substr(-4);
        },
        calculatePriorityFees(rowData) {
            // Calculate priority fees as rewards minus base fees
            // Base fee is 5000 lamports per transaction
            const baseFees = (rowData.txns || 0) * 5000;
            const totalRewards = rowData.rewards || 0;
            return Math.max(0, totalRewards - baseFees);
        },
        calculatePriorityPercentage(rowData) {
            // Calculate percentage of non-vote transactions that paid priority
            const nonVotes = (rowData.txns || 0) - (rowData.votes || 0);
            if (nonVotes <= 0) return '0.00';
            const priorityCount = rowData.fees?.count || 0;
            return ((priorityCount / nonVotes) * 100).toFixed(2);
        },
        calculateJitoPercentage(rowData) {
            // Calculate percentage of non-vote transactions that used Jito
            const nonVotes = (rowData.txns || 0) - (rowData.votes || 0);
            if (nonVotes <= 0) return '0.00';
            const jitoCount = rowData.fees?.jito_transactions || 0;
            return ((jitoCount / nonVotes) * 100).toFixed(2);
        },
        getPriorityTooltip(rowData) {
            const nonVotes = (rowData.txns || 0) - (rowData.votes || 0);
            const priorityCount = rowData.fees?.count || 0;
            return `${priorityCount} of ${nonVotes} user transactions paid priority fees`;
        },
        getJitoTooltip(rowData) {
            const nonVotes = (rowData.txns || 0) - (rowData.votes || 0);
            const jitoCount = rowData.fees?.jito_transactions || 0;
            return `${jitoCount} of ${nonVotes} user transactions used Jito`;
        },
        calculateRevPerCu(rowData) {
            // Skip if block was skipped
            if (rowData.skipped) return '-';

            // Get CU value (prefer Firedancer data if available)
            const cu = rowData.block_fd?.compute_units || rowData.cu || 0;
            if (cu === 0) return '-';

            // Calculate revenue: rewards + jito_total
            const rewards = rowData.rewards || 0;
            const jitoTotal = rowData.fees?.jito_total || 0;
            const totalRev = rewards + jitoTotal;

            // Calculate Rev/CU in lamports per compute unit
            const revPerCu = totalRev / cu;

            // Format to 1-2 decimal places to save table width
            if (revPerCu < 0.1) {
                return revPerCu.toFixed(2);
            }
            return revPerCu.toFixed(1);
        },
        getRevPerCuTooltip(rowData) {
            const rewards = rowData.rewards || 0;
            const jitoTotal = rowData.fees?.jito_total || 0;
            const totalRev = rewards + jitoTotal;
            const cu = rowData.block_fd?.compute_units || rowData.cu || 0;

            return `Revenue: ${this.formatSol(totalRev)} SOL / CU: ${this.formatCu(cu)}m`;
        },
        updateFilter() {
            this.$nextTick(() => {
                this.$refs.vuetable.reload();
            });
        },
        updateCustomSlotFilter() {
            if (this.customSlotRange.min && this.customSlotRange.max) {
                this.useCustomSlots = true;
                this.useDateRange = false;
                this.dateRange = null;
                this.slots = []; // Clear epoch selection
                this.updateFilter();
            }
        },
        updateDateFilter() {
            if (this.dateRange && this.dateRange.length === 2) {
                this.useDateRange = true;
                this.useCustomSlots = false;
                this.customSlotRange = { min: null, max: null };
                this.slots = []; // Clear epoch selection
                this.updateFilter();
            }
        },
        clearAdvancedFilters() {
            this.customSlotRange = { min: null, max: null };
            this.dateRange = null;
            this.useCustomSlots = false;
            this.useDateRange = false;
            this.updateFilter();
        },
        onRangeSelected(range) {
            if (range) {
                this.customSlotRange = {
                    min: range.min,
                    max: range.max
                };
                this.updateCustomSlotFilter();
                this.showAdvanced = true; // Show advanced panel when range is selected
            }
        },
        // when the pagination data is available, set it to pagination component
        onPaginationData(paginationData) {
            console.log('onPaginationData: ', paginationData)
            this.$refs.pagination.setPaginationData(paginationData)
            this.pageUrl = paginationData.first_page_url
            this.page = paginationData.current_page
        },
        // when the user click something that causes the page to change,
        // call "changePage" method in Vuetable, so that that page will be
        // requested from the API endpoint.
        onChangePage(page) {
            console.log('onChangePage: ', page)
            this.$refs.vuetable.changePage(page)
        }
    },
    computed: {
        filters() {
            let filters = {}
            
            if (this.leader) {
                filters["filter[leader.leader]"] = this.leader;
            }
            
            // Priority: custom slots > date range > epoch slots
            if (this.useCustomSlots && this.customSlotRange.min && this.customSlotRange.max) {
                filters["filter[slots]"] = `${this.customSlotRange.min},${this.customSlotRange.max}`;
            } else if (this.useDateRange && this.dateRange && this.dateRange.length === 2) {
                filters["filter[dateRange]"] = this.dateRange;
            } else if (this.slots.length) {
                filters["filter[slots]"] = this.slots;
            }
            
            return filters;
        },
        chartFilters() {
            // Simplified filters for chart API
            let filters = {};
            
            if (this.useCustomSlots && this.customSlotRange.min && this.customSlotRange.max) {
                filters.slots = `${this.customSlotRange.min},${this.customSlotRange.max}`;
            } else if (this.useDateRange && this.dateRange && this.dateRange.length === 2) {
                filters.dateRange = this.dateRange;
            } else if (this.slots.length) {
                filters.slots = this.slots;
            }
            
            return filters;
        }
    },
    watch: {
        pageUrl() {
            // get current query string from this.pageUrl
            var url = new URL(this.pageUrl);
            console.log('url', url)
            // get current query string from this.pageUrl
            var newQuery = url.searchParams;
            console.log('newQuery', newQuery)
            // set the page in the query string to the current page
            newQuery.set('page', this.page);
            // update browser history with the new query string
            let queryString = newQuery.toString()
            console.log('?'+ queryString)
            window.history.pushState(null, null, '?' + newQuery.toString());


        }
    }
}
</script>

<style >
.vuetable-body-wrapper {
    overflow-x: auto;

}
</style>
